module.exports = __webpack_public_path__ + "img/金属材料学4_2.97ffae2b.png";